import src from "IMAGE";
export default { src, width: 795, height: 198, blurWidth: 0, blurHeight: 0};
